import { UNITS } from '../../../resources/constants';
import ingredients, { TYPES } from '../../../resources/ingredients';
import {sumArray} from '../../../utilities/arrays';

/**
 * calculate
 * @param {*} setResults 
 * @param {*} state 
 * @returns 
 */
const calculate = (setResults, state) => {

   const { totalQuantity, solvent, solventPercent, unit, apiList } = state;

   const { specificGravity } = ingredients.find(x => x.type === TYPES.solvent && x.name === solvent.name);

   let results = {};

   const mgTog = 1 / 1000; //g/mg
   const toPerDecimal = 1/100;

   //solventQuantity
   //dimensional analysis: g * 1 * 1 = g
   results.solventQuantity = totalQuantity * solventPercent * toPerDecimal;

   //solventQuantityVolume: use specificGravity
   //dimensional analysis: ml * 1/g/ml = g
   results.solventQuantityVolume = results.solventQuantity * 1 / specificGravity;

   //Amount of API (g)
   //dimensional analysis: mg * g/mg * 1 = g or g*1 = g
   const unitMultiplier = unit === UNITS.mgPerGram ? mgTog : toPerDecimal;
   results.apiList = apiList.map(item => item.quantity * unitMultiplier * totalQuantity);

   //Vehicle (g)
   //dimensional analysis: g - (sum(g)+g) = g
   results.vehicle = totalQuantity - (sumArray(results.apiList) + results.solventQuantity);

   setResults(results);
   return results;
};

export default calculate;